import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var composeServiceApi = function composeServiceApi(transferHandler, serializer, deserializer, defaultConfig) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config, input) {
      var resolvedConfig, endpoint, request, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resolvedConfig = _objectSpread(_objectSpread({}, defaultConfig), config); // We may want to allow different endpoints from given config(other than region) and input.
              // Currently S3 supports additional `useAccelerateEndpoint` option to use accelerate endpoint.

              _context.next = 3;
              return resolvedConfig.endpointResolver(resolvedConfig, input);

            case 3:
              endpoint = _context.sent;
              _context.next = 6;
              return serializer(input, endpoint);

            case 6:
              request = _context.sent;
              _context.next = 9;
              return transferHandler(request, _objectSpread({}, resolvedConfig));

            case 9:
              response = _context.sent;
              return _context.abrupt("return", deserializer(response));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

export { composeServiceApi };